import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const TransparentPricingPreprodThankYouViewAsync = lazyLoad({
  loader: () =>
    import(
      /* webpackChunkName: "transparent-pricing-preprod-thank-you-view" */ './transparent-pricing-preprod-thank-you-view'
    ),
  componentName: 'TransparentPricingPreprodThankYouView',
});
